"use client";

import Link from "next/link";

import { LEGAL_COMPANY } from "@/content/company";
import { useLocale } from "@/lib/i18n/provider";
import { localizePath } from "@/lib/i18n/routing";

const PRIVACY_PHRASES = ["Privacy Policy", "Política de privacidad"] as const;

/**
 * Renders a form consent label with “Privacy Policy” linked to /legal/privacy-policy.
 * Plain-text `consentTextRecord` used for audit stays unlinked.
 */
export function ConsentPrivacyLabel({ text }: { text: string }) {
  const { locale } = useLocale();
  const privacyHref = localizePath(LEGAL_COMPANY.privacyUrl, locale);

  for (const phrase of PRIVACY_PHRASES) {
    const idx = text.indexOf(phrase);
    if (idx === -1) continue;
    return (
      <>
        {text.slice(0, idx)}
        <Link
          href={privacyHref}
          className="font-medium text-[var(--color-accent-base)] underline underline-offset-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          {phrase}
        </Link>
        {text.slice(idx + phrase.length)}
      </>
    );
  }
  return <>{text}</>;
}
